import {
    COOKIES_URL,
    TERMS_AND_CONDITIONS_EX_UK_URL,
    PRIVACY_POLICY_EX_UK_URL,
} from '../../../shared/endpoints/usingTheBbc';
import {
    ABOUT_THE_BBC_URL,
    ACCESSIBILITY_URL,
    PARENTAL_GUIDANCE_URL,
    CONTACT_THE_BBC_URL,
    PAN_BBC_NEWSLETTER_URL,
} from '../../../shared/endpoints/externalUrls';

export const footerItemsExUk = [
    {
        href: TERMS_AND_CONDITIONS_EX_UK_URL,
        id: 'common.link.footer.termsOfUse.value',
    },
    {
        href: ABOUT_THE_BBC_URL,
        id: 'common.link.footer.aboutBBC.value',
    },
    {
        href: PRIVACY_POLICY_EX_UK_URL,
        id: 'common.link.footer.privacyPolicy.value',
    },
    {
        href: COOKIES_URL,
        id: 'common.link.footer.cookieHelp.value',
    },
    {
        href: ACCESSIBILITY_URL,
        id: 'common.link.footer.accessibilityHelp.value',
    },
    {
        href: PARENTAL_GUIDANCE_URL,
        id: 'common.link.footer.parentalGuidance.value',
    },
    {
        href: CONTACT_THE_BBC_URL,
        id: 'common.link.footer.contactBBC.value',
    },
    {
        href: PAN_BBC_NEWSLETTER_URL,
        id: 'link.footer.newsletter.value',
    },
];
